$(function () {
	$('.contacts-page').each(function () {
		var map = $('#ymap');
		var coordinates = JSON.parse(JSON.stringify(map.data('coordinates')));
		var address = map.data('address');


		var baloonContnet = '<div class="map-balloon"><div class="map-balloon__img"></div><div class="map-balloon__address">' + address + '</div></div>';

		ymaps.ready(init);
		function init() {
			// Создаем карту.
			var myMap = new ymaps.Map("ymap",
				{
					center: [coordinates.lat, coordinates.lng],
					zoom: 15,
					yandexMapDisablePoiInteractivity: true,
					suppressObsoleteBrowserNotifier:true,
					suppressMapOpenBlock: true,
					controls: ['zoomControl']
				},
				{
					searchControlProvider: 'yandex#search'
				}),

				myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
					hintContent: '',
					balloonContent: ''
				}, {
					iconLayout: 'default#image',
					iconImageHref: __app.TEMPLATE_URI + 'images/map_mark.png',
					iconImageSize: [100, 100],
					iconImageOffset: [-50 , -50]
				})
			myMap.geoObjects
				.add(myPlacemark);

			myMap.panes.get('ground').getElement().style.filter = 'grayscale(100%)';
			myMap.behaviors.disable('scrollZoom');

			myMap.balloon.open([coordinates.lat, coordinates.lng], baloonContnet, {
				// Опция: не показываем кнопку закрытия.
				closeButton: false,
			});


		}
	});
});
